import type { ClassValue } from 'clsx';

import { clsxm } from '@vs-shop/utils';

import {
  ProductCardHeader as ProductCardHeaderPart,
  ProductCardTitle,
} from '@vs-shop/commerce-ui/productCard';

import Link from '@vs-shop/image-link/Link';

type Props = {
  productName: string;
  routerUrl: string;
  metaTitle: string;
  showRating?: boolean;
  showFavourite?: boolean;
  className?: ClassValue;
};

/**
 * The card's name block.
 *
 * The title renders as an `<h3>`: a product grid is a list of products, so each
 * name genuinely belongs to the page's outline, and screen-reader users
 * navigate the grid by heading. The shared part deliberately does not decide
 * that — it paints the type scale and leaves the element to whoever places the
 * section, which is here.
 */
export default function ProductCardHeader({
  productName,
  routerUrl,
  metaTitle,
  // showRating = true,
  className,
}: Props) {
  return (
    <ProductCardHeaderPart className={clsxm(className)}>
      <Link href={routerUrl} title={metaTitle} prefetch={false}>
        {/* oxlint-disable-next-line jsx-a11y/heading-has-content -- a TEMPLATE
            element: ProductCardTitle clones it with the name as children. */}
        <ProductCardTitle render={<h3 />}>{productName}</ProductCardTitle>
      </Link>

      {/* TODO: až se bude znovu zapojovat rating a review, tak došlo ke změně a obojí je nullable, je to tedy potřeba zohlednit + se musí změnit h-16 na asi h-20*/}
      {/*{showRating && (*/}
      {/*  <div className="flex gap-2 pt-2">*/}
      {/*    <RatingStars rating={rating} bgInverted />*/}
      {/*    <span className="text-xs leading-4 tracking-widest">{rating}</span>*/}
      {/*    <span className="text-xs leading-4 tracking-widest text-foreground/50">*/}
      {/*      ({reviewsCount})*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*)}*/}
    </ProductCardHeaderPart>
  );
}
